/* eslint-disable camelcase */
import React from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import LoadingButton from 'components/common/LoadingButton';
import FormikInputField from 'components/Fields/FormikInputField';
import CardWithTitle from 'components/CardWithTitle';
import { ADD_EDIT_CONSTANT } from 'utils/constants';

const AddEditNewsForm = (props) => {
  const { handleSubmit, isSubmitting, isValid, dirty, toggleFAQForm, type } =
    props;

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Row>
          <Col sm={12} className="mt-3">
            <Field
              label="News"
              name="settingValue"
              type="textarea"
              className="msg-field"
              component={FormikInputField}
              placeholder="Enter News Value"
              required
            />
          </Col>
        </Row>
      </CardWithTitle>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={toggleFAQForm}
        >
          Cancel
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="primary"
          size="sm"
          type="submit"
        >
          {type === ADD_EDIT_CONSTANT.EDIT ? 'Update' : 'Create'}
        </LoadingButton>
      </div>
    </Form>
  );
};

export default AddEditNewsForm;
